import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { AuthService } from '@/features/auth/auth.service';

@Component({
  selector: 'app-mobile-float-menu',
  standalone: true,
  imports: [CommonModule, RouterLink, BadgeModule],
  template: `
    <div class="mobile-float-menu fixed bottom-0 left-0 right-0 bg-verde-saude-base text-white shadow-lg z-[999]">
        <div class="flex items-center justify-around py-2">
            <button routerLink="/pagina-comprador" class="flex flex-col items-center p-2 text-white hover:text-white/90 transition-colors">
                <i class="pi pi-home text-lg mb-1"></i>
                <span class="text-xs">Início</span>
            </button>
            <button (click)="toggleFilters.emit()" class="flex flex-col items-center p-2 text-white hover:text-white/90 transition-colors">
                <i class="pi pi-filter text-lg mb-1"></i>
                <span class="text-xs">Filtros</span>
            </button>
            <button (click)="toggleCart.emit()" class="flex flex-col items-center p-2 text-white hover:text-white/90 transition-colors relative">
                <i class="pi pi-shopping-cart text-lg mb-1"></i>
                <span class="text-xs">Carrinho</span>
                <span *ngIf="cartCount > 0" class="absolute -top-1 right-2 bg-white text-verde-saude-base text-xs w-5 h-5 rounded-full flex items-center justify-center">{{cartCount}}</span>
            </button>
            <button (click)="accountMenuOpen = !accountMenuOpen" class="flex flex-col items-center p-2 text-white hover:text-white/90 transition-colors">
                <i class="pi pi-user text-lg mb-1"></i>
                <span class="text-xs">Minha conta</span>
            </button>
        </div>
    </div>

    <!-- Backdrop -->
    <div *ngIf="accountMenuOpen" class="fixed inset-0 z-[1000]" (click)="accountMenuOpen = false"></div>

    <!-- Account dropdown (abre para cima) -->
    <div *ngIf="accountMenuOpen" class="fixed bottom-[70px] right-4 z-[1001] w-64 bg-white rounded-xl shadow-xl overflow-hidden border border-slate-200">
      <button class="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-slate-50">
        <span class="inline-flex flex-col">
          <span class="text-xs text-slate-500">Colaborador: {{ nomeComprador || 'Não informado' }} - Carteira:{{ numeroCarteira || 'Sem Carteira' }}</span>
        </span>
      </button>
      <div class="h-px bg-slate-200"></div>
      <a class="flex items-center px-4 py-3 cursor-pointer hover:bg-slate-50 text-slate-700" (click)="accountMenuOpen = false">
        <span class="pi pi-inbox"></span>
        <span class="ml-2 text-sm">Mensagens</span>
        <p-badge class="ml-auto" value="2"></p-badge>
      </a>
      <div class="h-px bg-slate-200"></div>
      <a class="flex items-center px-4 py-3 cursor-pointer hover:bg-slate-50 text-slate-700" (click)="logout()">
        <span class="pi pi-sign-out text-red-500"></span>
        <span class="ml-2 text-sm">Logout</span>
      </a>
    </div>
  `,
  styles: [`
    .mobile-float-menu {
      backdrop-filter: blur(10px);
      padding-bottom: env(safe-area-inset-bottom);
      z-index: 999 !important;
      /* display: none; */ /* Handled by parent or media query logic usually, but here we enforce block if component is present and let parent handle *ngIf */
    }
    
    .mobile-float-menu button {
        min-width: 60px;
        transition: all 0.2s ease;
    }

    .mobile-float-menu button:hover {
        transform: translateY(-1px);
    }

    .mobile-float-menu button:active {
        transform: translateY(0);
    }
  `]
})
export class MobileFloatMenuComponent {
  @Input() cartCount: number = 0;
  @Output() toggleMenu = new EventEmitter<void>();
  @Output() toggleFilters = new EventEmitter<void>();
  @Output() toggleCart = new EventEmitter<void>();
  @Output() toggleAccount = new EventEmitter<void>();
  @Input() nomeComprador: string = '';
  @Input() numeroCarteira: string = '';

  accountMenuOpen = false;

   constructor(private auth: AuthService) {}

  logout(): void {
    this.accountMenuOpen = false;
    this.auth.logout();
  }
}